import { Component } from '@angular/core';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatChipSet, MatChip, MatChipRemove } from '@angular/material/chips';

@Component({
    selector: 'app-add-supplier-dialog',
    templateUrl: './add-supplier-dialog.component.html',
    styleUrls: ['./add-supplier-dialog.component.scss'],
    imports: [MatIconButton, MatIcon, MatChipSet, MatChip, MatChipRemove, MatButton]
})
export class AddSupplierDialogComponent {

}
